
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Analyse de site internet : outils, méthodes, SEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "L’analyse d’un site internet est une démarche cruciale pour tout propriétaire de site web ou spécialiste du marketing numérique souhaitant optimiser la présence en ligne et améliorer l’expérience utilisateur.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Analyse de site internet : outils, méthodes, SEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L’analyse d’un site internet est une démarche cruciale pour tout propriétaire de site web ou spécialiste du marketing numérique souhaitant optimiser la présence en ligne et améliorer l’expérience utilisateur.",
        },
      ],
    };
  },
};
